import { render } from "./PpcAutomationController.vue?vue&type=template&id=42ba94d0&scoped=true"
import script from "./PpcAutomationController.vue?vue&type=script&lang=js"
export * from "./PpcAutomationController.vue?vue&type=script&lang=js"

import "./PpcAutomationController.vue?vue&type=style&index=0&id=42ba94d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ba94d0"]])

export default __exports__